export const UPDATE_FACTSHEET_DATA:string = 'factsheet/UPDATE_FACTSHEET_DATA';